var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59.6641 40.2658V28.9654L118.495 17.613L119.326 32.7062",
  fill: "#D1C8B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.6589 40.2658V28.9654L0.671875 17.613V32.7062",
  fill: "#E5DFD7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.3342 91.8318L59.6589 126.616L0.671875 99.3914L60.3342 91.8318Z",
  fill: "#E5DFD7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.3359 111.133L119.998 99.3914L60.3359 91.8318V111.133Z",
  fill: "#D1C8B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.2573 25.0167L59.6599 28.9654L23.0625 23.0684L38.7768 17.613L80.2573 25.0167Z",
  fill: "#BDB09B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.3359 0V20.9642L67.5307 25.0167L119.115 32.7062L118.388 17.639L40.3359 0Z",
  fill: "#E5DFD7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.3377 0L0.363636 17.639L0 32.7062L26.3896 25.0167L40.3377 20.9642V0Z",
  fill: "#F2EFEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.7536 90.0914L41.2731 75.6477H30.5198L28.1822 79.96C26.5458 83.0254 24.2601 87.3378 23.0653 90.2992C23.1692 87.2858 23.2471 83.9347 23.2471 80.2977V75.6477H13.6367V115.446H23.2471V102.197L25.6367 98.7421L31.377 115.446H42.0004L32.7536 90.0914Z",
  fill: "#003E7E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.4825 95.5988C59.4825 105.211 58.002 107.886 55.041 107.886C52.0799 107.886 50.5475 105.107 50.5475 95.4948C50.5475 85.883 51.9761 83.2073 54.989 83.2073C57.9501 83.2073 59.4825 85.9869 59.4825 95.5988ZM69.2488 95.4689C69.2488 81.4928 63.9501 74.9983 55.041 74.9983C46.1059 74.9983 40.7812 81.5447 40.7812 95.5728C40.7812 109.601 46.002 116.043 54.9371 116.043C63.9241 116.069 69.2488 109.523 69.2488 95.4689Z",
  fill: "#003E7E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M95.1715 78.4531H69.5352V86.7401H77.6131V118.251H87.0936V86.7401H95.1715V78.4531Z",
  fill: "#003E7E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.181 75.6477H98.5703V115.446H108.181V75.6477Z",
  fill: "#003E7E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.53232 144.619L40.7791 174V111.133L0.441406 99.3914L1.53232 144.619Z",
  fill: "#F2EFEB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7812 111.133V174L117.872 144.619L120.002 99.3914L40.7812 111.133Z",
  fill: "#E5DFD7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.3992 66.6333C30.8797 66.6333 29.555 64.2434 29.555 56.0343C29.555 47.8253 30.7758 45.5133 33.3472 45.5133C35.8667 45.5133 37.1914 47.9033 37.1914 56.1123C37.1914 64.3473 35.9187 66.6333 33.3992 66.6333ZM33.3992 38.4993C25.7628 38.4993 21.1914 44.0845 21.1914 56.1123C21.1914 68.14 25.6589 73.6214 33.2953 73.6214C40.9836 73.6214 45.555 68.0361 45.555 56.0084C45.555 44.0585 41.0356 38.4993 33.3992 38.4993Z",
  fill: "#003E7E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.9059 32.3945L63.4513 33.044L61.1656 41.7726C59.9968 46.1628 59.0617 50.2673 58.776 52.7352C58.1267 50.3453 56.4124 46.3707 54.5942 42.396L50.776 34.161L43.2695 34.8105L46.3085 69.4131L53.815 68.7636L53.1397 61.1001C52.828 57.3853 52.4124 53.9302 52.0747 51.0727C53.0617 53.7224 54.828 57.9568 56.2306 60.9183L60.2565 69.2832L62.75 60.3468C63.6591 57.1775 64.6202 52.7093 65.1137 49.9296C65.2176 52.9171 65.4773 56.2682 65.789 59.9831L66.4643 67.6466L73.9189 66.9971L70.9059 32.3945Z",
  fill: "#003E7E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.3487 37.0186H78.7772L69.7383 71.9588H78.3097L79.5565 65.4644H86.4396L87.7383 71.9588H96.3097L87.3487 37.0186ZM80.9331 58.6841L81.1409 57.5931C81.998 52.943 82.6993 49.1502 82.985 45.955C83.3227 49.1502 84.0759 52.943 84.8811 57.5411L85.0889 58.6841H80.9331Z",
  fill: "#003E7E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.9864 122.85L94.5709 123.421L94.2852 134.929L96.7007 134.332L96.9864 122.85Z",
  fill: "#003E7E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.467 137.787L83.8436 137.449L80.9864 126.746L77.7397 127.525L74.2852 139.761L75.7657 139.397C75.7657 139.397 76.6488 139.189 76.9345 138.176C77.1163 137.527 77.2981 136.903 77.2981 136.903L81.0124 135.994C81.0124 135.994 81.1942 136.618 81.3241 137.111C81.5319 138.02 82.467 137.787 82.467 137.787ZM80.467 134.02L77.8696 134.643L78.9085 130.799C79.0384 130.305 79.1942 129.708 79.1942 129.318L79.3501 129.292C79.3501 129.682 79.454 130.201 79.5838 130.643L80.467 134.02Z",
  fill: "#003E7E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.415 131.994L107.791 131.656L104.934 120.953L101.688 121.732L98.207 133.968L99.6875 133.604C99.6875 133.604 100.571 133.396 100.856 132.383C101.038 131.734 101.22 131.11 101.22 131.11L104.934 130.201C104.934 130.201 105.116 130.825 105.246 131.318C105.454 132.202 106.415 131.994 106.415 131.994ZM104.415 128.227L101.817 128.85L102.856 125.006C102.986 124.512 103.142 123.915 103.142 123.525L103.298 123.499C103.298 123.889 103.428 124.408 103.532 124.85L104.415 128.227Z",
  fill: "#003E7E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63.3745 142.411L60.9329 139.553C62.3615 138.618 63.1147 137.163 63.1667 135.293C63.2446 132.461 61.6342 131.396 59.1407 131.994L54.4654 133.137L54.1797 144.593L56.6992 143.969L56.7771 141.138L58.4654 140.722C58.4654 140.722 59.9199 142.307 60.1277 142.593C60.5433 143.112 61.2446 142.904 61.2446 142.904L63.3745 142.411ZM60.7511 135.994C60.7251 137.527 59.9979 138.073 58.7251 138.384L56.829 138.852L56.9329 134.643L58.9589 134.15C60.2576 133.838 60.7771 134.669 60.7511 135.994Z",
  fill: "#003E7E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.6099 130.435L65.3242 141.943L72.5191 140.203L72.3372 138.098L67.7918 139.215L67.8437 137.059L71.7918 136.098L71.8437 133.968L67.8957 134.929L67.9736 131.994L72.3632 130.929L72.4151 128.798L65.6099 130.435Z",
  fill: "#003E7E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.7662 125.551L85.4805 137.059L92.6493 135.319L92.4675 133.189L87.974 134.28L88.1818 124.979L85.7662 125.551Z",
  fill: "#003E7E"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 174,
  fill: "white"
})));

function SvgOmaKotiLogoRealia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 174,
    viewBox: "0 0 120 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmaKotiLogoRealia);
export default __webpack_public_path__ + "static/media/omaKotiLogoRealia.30fbcaf10a0935fac50bbfaf1619b160.svg";
export { ForwardRef as ReactComponent };